var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"Component",staticClass:"hyper-link",class:[
    ("hyper-link--" + _vm.color),
    { 'hyper-link--center' : _vm.center }
  ],attrs:{"to":_vm.to}},[_c('MoreArrowIcon',{staticClass:"hyper-link__icon",class:("hyper-link__icon--" + _vm.color)}),_vm._v(" "),_c('span',{staticClass:"hyper-link__text",class:("hyper-link__text--" + _vm.color)},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }